<dx-popup title="{{ 'Makros' | translate }}"
          [width]="1200"
          [height]="800"
          [dragEnabled]="false"
          [showTitle]="true"
          [showCloseButton]="true"
          [hideOnOutsideClick]="true"
          [(visible)]="visible"
          [fullScreen]="fullScreen"
          contentTemplate="popupContent"
          enableBodyScroll="false">
  <dxi-popup-toolbar-item *ngIf="fullScreen" toolbar="top" location="after" widget="dxButton" [options]="{ stylingMode: 'outlined', icon: 'collapse', onClick: toggleFullscren }"></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item *ngIf="!fullScreen" toolbar="top" location="after" widget="dxButton" [options]="{ stylingMode: 'outlined', icon: 'fullscreen', onClick: toggleFullscren }"></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
    <np-help-button>
      <np-help-option text="Wiki" icon="icon-glyphicons-basic-588-book-open-text"
                      link="https://knowledge.nextpim.de/makros?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink"></np-help-option>
      <np-help-option text="YouTube" icon="icon-glyphicons-basic-basic-856-square-play"
                      link="https://www.youtube.com/watch?v=gHtxkwiks9k"></np-help-option>
    </np-help-button>
  </dxi-popup-toolbar-item>


  <div *dxTemplate="let data of 'popupContent'">
    <userAction [(macro)]="macro" [(parameter)]="parameter" [(editMode)]="editMode" [catalogId]="catalogId" (onMacroStart)="closePopUp()"  (onMacroSave)="saveMacro($event)" ></userAction>
  </div>
</dx-popup>
